import { render, staticRenderFns } from "./CustomLink.vue?vue&type=template&id=423a7637&"
import script from "./CustomLink.vue?vue&type=script&lang=js&"
export * from "./CustomLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports